export default "__VITE_ASSET__B2ZTB$dx__"